import parseSettingsFromContext from "features/Letterbooks/utils/parseSettingsFromContext";
import LetterbooksWrapper from "./LetterbooksWrapper/LetterbooksWrapper";
import { LetterbooksSerializersLetterbooks } from "types/serializers";

interface LetterbookOptions {
  context: LetterbooksSerializersLetterbooks;
}

export default function Letterbooks({ context }: LetterbookOptions) {
  const settings = parseSettingsFromContext(context);
  return <LetterbooksWrapper settings={settings} />;
}
